import CompteOuvertsExportController from './compte.ouverts.export.controller.js';

export default {
    template: require('./compte.ouverts.export.html'),
    controller: CompteOuvertsExportController
};
